"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateMMDDYYYY = void 0;
/**
 * Formats a `Date` as `MM/DD/YYYY` using its UTC calendar fields.
 *
 * Date-only values (e.g. `"2026-10-01"`) are parsed as UTC midnight, so
 * formatting them with local getters shifts the day backwards in
 * negative-offset timezones. Leasing Journey treats a move-in date that is one
 * day early as the unit being unavailable, so this formatting must stay
 * UTC-based to keep move-in dates consistent across services.
 */
var formatDateMMDDYYYY = function (date) {
    var month = date.getUTCMonth() + 1;
    var day = date.getUTCDate();
    var year = date.getUTCFullYear();
    return ((month > 9 ? month : '0' + month) +
        '/' +
        (day > 9 ? day : '0' + day) +
        '/' +
        year);
};
exports.formatDateMMDDYYYY = formatDateMMDDYYYY;
